<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar && !$route.meta.hideSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarActiveColor"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
      :title="appTitle"
      :subtitle="account.userArea"
    >
      <user-menu
        :title="account.firstName + ' ' + account.lastName"
        :subtitle="account.userRole"
        :avatar="account.avatar"
      ></user-menu>
      <!-- <view-as-switcher currentGroup="account.group" v-model="selectedGroup" v-if="$isAdmin" /> -->
      <mobile-menu></mobile-menu>

      <routing slot="links"></routing>
    </side-bar>
    <support-chat
      class="support-chat"
      v-if="$can('avi_login', 'AVIChat', 'avitoken') && (isQA || isDev)"
    />
    <div class="main-panel">
      <top-navbar />
      <md-content class="environment-warning" v-if="isQA">
        <strong>ADVERTENCIA. ENTORNO DE PRUEBA.</strong>
        <br />Los datos son volátiles y pueden ser eliminados en cualquier momento. Por favor, proteja su trabajo adecuadamente.
      </md-content>
      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <md-progress-bar class="md-accent page-progress" md-mode="query" v-if="pageLoading" />
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->

          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import SupportChat from "@/components/SupportChat.vue";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import Vue from "vue";
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
// import ViewAsSwitcher from "./Extra/ViewAsSwitcher.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import Routing from "@/components/Routing";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition,
    Routing,
    // ViewAsSwitcher,
    SupportChat,
  },
  data() {
    const sidebarBackgroundColor = Vue.config.debug ? "red" : "black";
    const isQA = window.location.href.startsWith("https://qa.");
    const appTitle = Vue.config.appName;

    return {
      sidebarBackgroundColor,
      sidebarActiveColor: "green",
      sidebarBackgroundImage: require("@/assets/images/sidebar-2.jpg"),
      sidebarMini: true,
      sidebarImg: true,
      isQA,
      isDev: Vue.config.debug,
      appTitle,
      selectedGroup: null,
      groups: [{ slug: "foo", name: "Group Foo" }],
      chatVisible: false,
    };
  },
  computed: {
    ...mapState(["account"]),
    ...mapGetters({
      pageLoading: "app/pageLoading",
    }),
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    showChat() {
      this.chatVisible = !this.chatVisible;
    },
  },
  mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");
      initScrollbar("main-panel");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.page-progress {
  margin-bottom: -4px !important;
}

.environment-warning {
  background-color: md-get-palette-color(amber, A200) !important;
  justify-content: center;
  align-items: center;
  padding-left: 32px;
}
.support-chat {
  position: fixed;
  top: 95%;
  right: 0%;
  z-index: 5;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/DashboardLayout.vue